import PageHero from '@/components/feature/PageHero';

export default function SettlementHero() {
  return (
    <PageHero
      eyebrow="九畴云铺 · 价值分配"
      title="每一笔价值，都有记录"
      titleHighlight="透明清分账本"
      desc="订单、贡献、规则、计算、清分、对账——七方共利清分系统，让多方协同的价值分配可追溯、可对账。"
      imageUrl="https://readdy.ai/api/search-image?query=Abstract%20transparent%20ledger%20visualization%20with%20glowing%20data%20rows%2C%20deep%20dark%20ink%20navy%20background%2C%20emerald%20and%20gold%20light%20streams%20flowing%20through%20ledger%20grid%2C%20digital%20value%20distribution%2C%20futuristic%20financial%20clarity%2C%20minimal%20geometric%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1800&height=1100&seq=jiuchou-settle-01&orientation=landscape"
      imageAlt="九畴云铺 透明清分账本"
      imageTitle="九畴云铺 透明清分账本"
    />
  );
}